import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-button-specs',
  templateUrl: './icon-button-specs.component.html',
  styleUrls: ['./icon-button-specs.component.sass']
})
export class IconButtonSpecsComponent implements OnInit {
  public component = window.location.protocol + '//' + window.location.host + '/design-specs-measure/icon-button/';
  constructor() { }

  ngOnInit(): void {
  }

  clickEvent(route) {
    if(route == 'light') {
      window.open(this.component, "_blank");
    }
  }

}
